import { Observable, firstValueFrom, from } from 'rxjs';

import { DexieService } from './dexieService';
import { EquipmentType } from '../model/equipmentType';
import { HttpClient } from '@angular/common/http';
import { HttpUtils } from '../utils/httpUtils';
import { Injectable } from '@angular/core';
import { OnlineService } from './online.service';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class EquipmentTypeAirService {

    constructor(private http: HttpClient,
        private dexieService: DexieService,
        private onlineService: OnlineService) {
    }

    findAll(): Observable<any> {
        if (this.onlineService.latestOnline) {
            const url = environment.coreUrl + '/equipmentType/air';

            return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
        } else {
            return from(this.dexieService.equipmentTypesAir.toArray().timeout(30000));
        }
    }

    findOne(id: number): Observable<any> {
        const url = environment.coreUrl + '/equipmentType/air/' + id;

        return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }

    async saveEquipmentTypeToDexie(): Promise<void> {
        const res = await firstValueFrom(this.findAll());
        if (!res) return;

        await this.dexieService.equipmentTypesAir.clear();

        await Promise.all(res.map(data => this.dexieService.equipmentTypesAir.put(data, data.id)));
    }
}
